export default __webpack_public_path__ + "static/media/overviewPic-TW.ee4b8a4d.png";